module.exports = __webpack_public_path__ + "static/media/ts14cr823.a4f5d23b.png";